import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { store } from "./store/store";
import * as Sentry from '@sentry/react';
import { SENTRY_DSN, SENTRY_ENVIRONMENT, SENTRY_RELEASE } from './constants/enviroment';
import { loadMetrics } from './utils/loadMetrics';

import App from "./App";

if (import.meta.env.MODE === 'production') {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    ...(SENTRY_RELEASE !== undefined && { release: SENTRY_RELEASE }),
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    attachStacktrace: true,
  });

  loadMetrics();
}

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <App />
  </Provider>
);
